import React, { useReducer, createContext, useContext } from 'react';

import { ProviderProps } from 'commons/utils/types/provider';

import { migrate } from 'domains/orders/save-on-shipping/services';

import {
  initialState,
  ExternalShipmentState,
  Action,
  externalShipmentReducer
} from './reducer';

type ExternalShipmentContextType = {
  state: ExternalShipmentState;
  dispatch: React.Dispatch<Action>;
};

const ExternalShipmentsContext = createContext<
  ExternalShipmentContextType | undefined
>(undefined);

const useExternalShipments = (): ExternalShipmentContextType => {
  const [state, dispatch] = useReducer(externalShipmentReducer, initialState);

  return { state, dispatch };
};

const useExternalShipmentsContext = (): ExternalShipmentContextType => {
  const context = useContext(ExternalShipmentsContext);

  if (!context) {
    throw new Error(
      'useExternalShipmentsContext must be used within a ExternalShipmentsProvider'
    );
  }

  return context;
};

const ExternalShipmentsProvider: React.FC<ProviderProps> = ({ children }) => {
  const externalShipments = useExternalShipments();

  return (
    <ExternalShipmentsContext.Provider value={externalShipments}>
      {children}
    </ExternalShipmentsContext.Provider>
  );
};

type UseExternalShipmentsActionsType = {
  handleMigrate: (externalDeliveryOrders: string[]) => Promise<string[]>;
  handleChangeQuotation: () => Promise<void>;
};

export const useExternalShipmentsActions =
  (): UseExternalShipmentsActionsType => {
    const handleMigrate = async (externalDeliveryOrders: string[]) => {
      return await migrate(externalDeliveryOrders);
    };

    const handleChangeQuotation = async () => {
      return;
    };

    return {
      handleMigrate,
      handleChangeQuotation
    } as const;
  };

export { useExternalShipmentsContext, ExternalShipmentsProvider };
